import React, { useEffect, useState } from "react";
import { Table, Row, Col, Space } from "antd";
import { EyeOutlined, DeleteOutlined, ApiOutlined, CheckCircleOutlined } from "@ant-design/icons";
import columns from "@staticData/admin/adminMessagesTableColumns";
import moment from "moment-jalaali";
import DeactivateMessage from "@general/deacticateMessage";
import ActivateMessage from "@general/activateMessage";

function MessagesTable({
    data,
    onPageChange,
    currentPage,
    onSort,
    loading,
    onOpenDrawer,
    onDataUpdate,
}) {
    const [tableData, setTableData] = useState([]);
    const { getMessagesCount: count, getMessages: messages } = data;
    useEffect(() => {
        const initialTableData = [];
        messages.map((messages) => {
            const {
                id,
                createdAt,
                updatedAt,
                expiresAt,
                isActive,
                title,
                body
            } = messages;
            initialTableData.push({
                key: id,
                isActive,
                title,
                body,
                createdAt: moment(createdAt).format("jYYYY/jMM/jDD"),
                updatedAt: moment(updatedAt).format("jYYYY/jMM/jDD"),
                expiresAt: expiresAt ?  moment(expiresAt).format("jYYYY/jMM/jDD") : "بدون انقضا",
                details: (
                    <Space>
                        <a onClick={() => onOpenDrawer(id)}>
                            <EyeOutlined />
                        </a>
                        |
                        {!isActive ? (
                            <ActivateMessage
                                id={id}
                                title={title}
                                onActivateMessage={onDataUpdate}
                            >
                                <a>
                                    <CheckCircleOutlined />
                                </a>
                            </ActivateMessage>
                        ) : (
                            <DeactivateMessage
                                id={id}
                                title={title}
                                onDeactivateMessage={onDataUpdate}
                            >
                                <a>
                                    <ApiOutlined />
                                </a>
                            </DeactivateMessage>
                        )}
                    </Space>
                ),
            });
        });
        setTableData(initialTableData);
    }, [messages]);

    const onChange = (pagination, filters, sorter, extra) => {
        if (extra.action === "sort") {
            onSort(sorter);
        }
        if (extra.action === "paginate") {
            onPageChange(pagination.current);
        }
    };

    return (
        <>
            <Row>
                <Col span={24}>
                    <Table
                        columns={columns}
                        dataSource={tableData}
                        pagination={{
                            total: count,
                            current: currentPage,
                            showSizeChanger: false,
                        }}
                        onChange={onChange}
                        loading={loading}
                        scroll={{ x: 800 }}
                    />
                </Col>
            </Row>
        </>
    );
}

export default MessagesTable;
